import * as React from 'react';
import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
`;

const Name = styled.span`
  font-weight: bold;
  display: block;
  line-height: 20px;
  text-transform: capitalize;

  span {
    font-weight: normal;
    text-transform: none;
  }
`;

const Footer = styled.span`
  opacity: 0.7;
  font-size: 13px;
  line-height: 16px;
`;

const ValueWrapper = styled.div`
  display: flex;
  align-items: center;
`;

interface Props {
  label: string;
  value?: string | null;
  buttonLabel?: string;
  disabled?: boolean;
  disruptive?: boolean;
  meta?: string | null;
  footer?: string;
  onClick?: () => void;
}

export default class extends React.Component<Props> {
  render() {
    return (
      <Row>
        <span>{this.props.label}:</span>
        <ValueWrapper>
          <div style={{ textAlign: 'right' }}>
            <Name>
              {this.props.value || 'Loading...'}
              {this.props.meta && <span> ({this.props.meta})</span>}
            </Name>
            {this.props.footer && <Footer>{this.props.footer}</Footer>}
          </div>
          {this.props.buttonLabel && (
            <button
              style={{ marginLeft: 20 }}
              className={
                'medium ' + (this.props.disruptive ? 'disruptive' : 'primary')
              }
              disabled={this.props.disabled}
              onClick={this.props.onClick}
            >
              {this.props.buttonLabel}
            </button>
          )}
        </ValueWrapper>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/account/components/RowWithButton.tsx